import React, { ChangeEvent } from 'react';

type Props = {
  setComment: (string) => void;
  comment: string;
};

const DishComment: React.FC<Props> = ({ setComment, comment }) => {
  return (
    <>
      {
        <div className="flex flex-row w-full p-4">
          <input
            id="comment"
            type="text"
            placeholder="Comment"
            value={comment}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              setComment(e.target.value)
            }
            className="appearance-none bg-surface-variant block w-full px-3 py-2 border border-surface-variant rounded-md placeholder-on-surface-variant/60 focus:ring-primary/70 focus:border-primary text-on-surface-variant transition duration-150 ease-in-out text-md sm:leading-5"
          />
        </div>
      }
    </>
  );
};

export default DishComment;
